<template>
  <v-form>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-card v-if="!this.secret">
      <HeaderDividerBlock headerText="Create New User"></HeaderDividerBlock>
      <v-container class="pa-6">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.employer_no"
              required
              label="Employee ID*"
              :error-messages="this.fieldErrors.employer_no"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.full_name"
              required
              label="Full Name*"
              :error-messages="this.fieldErrors.full_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.email"
              required
              label="Email*"
              :error-messages="this.fieldErrors.email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="form.role_name"
              :items="role_names"
              :item-text="'name'"
              :item-value="'name'"
              label="Role*"
              dense
              outlined
              multiple
              :error-messages="this.fieldErrors.role_name"
            ></v-select>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.speciality"
              :items="specialities"
              label="Speciality*"
              :item-text="'name'"
              :item-value="'uuid'"
              dense
              outlined
              clearable
              :error-messages="this.fieldErrors.speciality"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.cph"
              required
              :label="`Cost Per Hour* (${currencyCode})`"
              :error-messages="this.fieldErrors.cost_per_hour"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.phone"
              required
              label="Phone"
              :error-messages="this.fieldErrors.phone"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.mobile"
              required
              label="Mobile"
              :error-messages="this.fieldErrors.mobile"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.address1"
              label="Address 01"
              :error-messages="this.fieldErrors.address1"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.address2"
              label="Address 02"
              :error-messages="this.fieldErrors.address2"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.city"
              label="City"
              :error-messages="this.fieldErrors.city"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.state"
              label="State"
              :error-messages="this.fieldErrors.state"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.branch"
              :items="branches"
              label="Branch"
              :item-text="'name'"
              :item-value="'uuid'"
              dense
              outlined
              clearable
              :error-messages="this.fieldErrors.branch"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              outlined
              dense
              v-model="form.country"
              label="Country"
              :error-messages="this.fieldErrors.country"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="#00B3FF"
              dark
              depressed
              :loading="loading"
              block
              @click="create()"
              >Create</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
    <Snackbars
      :text="'Validation error please scroll up'"
      :snackbar="snackbarError"
      :color="'red'"
      @classSnackbar="closeSnackbar"
    />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { EmployerService } from "@/services/employer-service.js";
import { checkError } from "@/config/errors.js";
import { ProjectService } from "@/services/project-service.js";
import Snackbars from "@/components/shared/Snackbars";
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers('settings');

export default {
  name: "CreateEmployer",
  components: { Alert, Snackbars, HeaderDividerBlock },
  props: ["name"],
  data: () => ({
    form: {
      employer_no: "",
      full_name: "",
      email: "",
      status: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      cph: "",
      speciality: "",
      phone: "",
      mobile: "",
      branch: "",
      country:"",
    },

    snackbar: false,
    QR: "",
    secret: null,
    employer_data: "",
    snackbarError: false,
    successMsg: "Employer has been created successfully",
    errors: null,
    loading: false,
    role_names: [],
    specialities: [],
    branches: [],
    fieldErrors: [],
  }),

  computed: {
    ...mapSettingsGetters({
      currencyCode: 'currencyCode',
    }),
  },

  mounted() {
    this.getRolesList();
    this.getSpecialities();
    this.getProjectBranches();
  },

  methods: {
    create() {
      this.loading = true;
      this.errors = null;
      let fd = new FormData();

      fd.append("employer_no", this.form.employer_no);
      fd.append("full_name", this.form.full_name);
      fd.append("email", this.form.email);
      fd.append("address1", this.form.address1 || "");
      fd.append("address2", this.form.address2 || "");
      fd.append("city", this.form.city || "");
      fd.append("state", this.form.state || "");
      fd.append("role_name", this.form.role_name || "");
      fd.append("cost_per_hour", this.form.cph || "");
      fd.append("speciality", this.form.speciality || "");
      fd.append("phone", this.form.phone || "");
      fd.append("mobile", this.form.mobile || "");
      fd.append("branch", this.form.branch || "");
      fd.append("country", this.form.country || "");

      this.loading = true;
      EmployerService.createEmployer1(fd)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.reset();
            this.snackbar = true;
            this.snackbarError = false;
            this.$router.push("/employers");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.fieldErrors = data.errors;
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    getRolesList() {
      this.loading = true;
      EmployerService.getRolesList()
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.role_names = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getSpecialities() {
      this.loading = true;
      EmployerService.getSpecialities()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.specialities = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    getProjectBranches() {
      this.loading = true;
      ProjectService.getProjectBranches()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.branches = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },
  },
};
</script>

